import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import TimelineSection from './components/TimelineSection';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />

        <FeaturedArticles />

        <CategoryGrid />

        <TimelineSection />

        <LatestArticles />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              开启香港电影探索之旅
            </h2>
            <p className="text-foreground-600 max-w-xl mx-auto mb-6 text-sm leading-relaxed">
              从分级制度的诞生到经典影片的诞生，从影人的传奇故事到文化现象的深度解析
              ——港片影志为您呈现最完整的香港三级片影史全貌。
            </p>
            <a
              href="/category/jingdian-tuijian"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-film-line"></i>
              立即探索
            </a>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '港片影志 - 香港三级片影史全解析',
            url: 'https://pczqmcf.cn',
            description:
              '系统梳理香港三级片的分级制度演变、经典作品解析与文化影响研究，为影迷提供专业的影史参考。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://pczqmcf.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '港片影志',
            url: 'https://pczqmcf.cn',
            description: '香港电影影史专业研究平台',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'contact@pczqmcf.cn',
              contactType: 'customer service',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '香港三级片影史全解析与文化回顾',
            description:
              '深度回顾香港三级片的发展历史、经典代表作品与文化影响。系统梳理分级制度的由来、黄金时代标志性影片及华语影坛独特地位。',
            url: 'https://pczqmcf.cn',
            isPartOf: {
              '@type': 'WebSite',
              name: '港片影志',
            },
          }),
        }}
      />
    </>
  );
}